const GlobalURLPattern =
  typeof URLPattern === 'undefined' ? undefined : URLPattern

export { GlobalURLPattern as URLPattern }
